export default function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}


//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/ramda/es/internal/_reduced.js
// module id = 180
// module chunks = 69